/**
 * Format a number as GBP currency with 2 decimal places
 * @param {number|string} amount - The amount to format
 * @returns {string} Formatted currency string with £ symbol
 */
export const formatCurrency = amount => {
  const numericAmount =
    typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numericAmount)) {
    return '£0.00';
  }

  return `£${numericAmount.toFixed(2)}`;
};

/**
 * Format a number as a decimal with 2 decimal places (without currency symbol)
 * @param {number|string} amount - The amount to format
 * @returns {string} Formatted decimal string
 */
export const formatDecimal = amount => {
  const numericAmount =
    typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numericAmount)) {
    return '0.00';
  }

  return numericAmount.toFixed(2);
};
